import { render, staticRenderFns } from "./JournalContent.vue?vue&type=template&id=49c8205d&scoped=true&"
import script from "./JournalContent.vue?vue&type=script&lang=js&"
export * from "./JournalContent.vue?vue&type=script&lang=js&"
import style0 from "./JournalContent.vue?vue&type=style&index=0&lang=less&"
import style1 from "./JournalContent.vue?vue&type=style&index=1&id=49c8205d&lang=less&scoped=true&"
import style2 from "./JournalContent.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c8205d",
  null
  
)

export default component.exports